import { Button, Typography } from '@mui/material';
import { downGradeOfferModalSxs } from '../newChangePlan';
import {
  downGradeOfferModalTexts,
  hireUsLink
} from 'src/common/config/TextMessage';
import { getHireUs } from 'src/common/Scraper';
import { openNewTab } from 'src/common/config/FunctionHelper';
import { RootState } from 'src/redux/store';
import { useSelector } from 'react-redux';

export const HiringSomeoneToDoItForMeInstead = ({ selectedTimeLine = '' }) => {
  let userDetails: any =
    useSelector((state: RootState) => state.counter.userDetails) ?? {};

  return (
    <>
      <Typography sx={downGradeOfferModalSxs?.offerCardHeadTextSx}>
        {downGradeOfferModalTexts?.hireUsTitle}
      </Typography>
      <Typography sx={downGradeOfferModalSxs?.offerCardDescTextSx}>
        {downGradeOfferModalTexts?.hireUsDesc}
      </Typography>
      <Button
        variant="contained"
        fullWidth
        sx={downGradeOfferModalSxs?.offerCardBtnSx}
        onClick={async () => {
          let response = await getHireUs();
          openNewTab(hireUsLink);
        }}
      >
        {downGradeOfferModalTexts?.hireUsBtnText}
      </Button>
    </>
  );
};
